module.exports = __webpack_public_path__ + "img/2-ob2.f55fbfd7.png";